<template>
	<div class="about-modal full-screen-modal">
		<div class="header-wrapper">
			<h1 class="heading">{{ ui.modal_heading }}</h1>
			<Button class="close-btn" :action="close" />
		</div>
		<div class="content">
			<div class="section" v-for="content in ui.content" :key="content.url">
				<div class="section-heading">{{ content.heading }}</div>
				<div class="wysiwyg-content" v-html="content.paragraph" />
			</div>
		</div>
		<div class="about-footer">
			<div class="about-footer-link" v-for="{ link } in ui.links" :key="link.url">
				<a :href="link.url" :target="link.target">{{ link.title }}</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from '@/components/base/Button';

export default {
	name: 'AboutModal',
	components: {
		Button,
	},
	computed: {
		...mapState({
			ui: (state) => state.global.api.data.ui.info.about,
		}),
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		close() {
			this.deactivateModal();
			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.about-modal {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.icon-tracker { margin-right: auto; }
	.close-btn { margin-left: auto; }

	.heading {
		font-family: $heading-font;
		font-size: 	$heading-size-sm;
		letter-spacing: $letter-spacing-plus;
		text-transform: uppercase;
		text-align: center;
		line-height: 1;
		position: absolute;
		right: 0;
		left: 0;
		margin: auto;
	}

	.content {
		width: 80%;
		max-width: $max-content-width;
		margin: 40px auto 20px;
	}

	.section {
		width: 80%;
		max-width: $max-content-width;
		text-align: center;
		margin: auto auto 20px;

		@include desktop { margin-bottom: 40px; }
	}

	.wysiwyg-content { font-size: $font-size-sm }

	.section-heading,
	.about-footer-link {
		text-transform: uppercase;
		font-size: $font-size-lg;
	}

	.about-footer {
		width: 80%;
		margin: 0 auto $page-bottom-spacing;

		@include desktop {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 1000px;
		}
	}

	.about-footer-link {
		text-align: center;
		margin-bottom: 20px;

		@include desktop { margin: 0; }

		&:last-child { margin-bottom: 0; }
	}
</style>
